<template>
  <div class="NewImagesHandler d-flex">
    <input v-if="!hideFileInput" ref="input" type="file" id="placeholder-input" style="display: none" accept="image/*" @change="change" multiple>

    <div v-if="!files.length" class="flex-grow-1 d-flex justify-content-center align-items-center">
      <div class="d-flex flex-column align-items-center">
        <svg width="80" height="80" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3.9165" y="9.75" width="30.0833" height="24.25" rx="1" fill="white" stroke="#D1D3D4" stroke-width="2"/>
          <mask id="path-2-outside-1_591_4231" maskUnits="userSpaceOnUse" x="5" y="18" width="28" height="12" fill="black">
          <rect fill="white" x="5" y="18" width="28" height="12"/>
          <path d="M23.4491 20L17.2501 27.2L12.8222 22.7L8 29H30.0909L23.4491 20Z"/>
          </mask>
          <path d="M23.4491 20L17.2501 27.2L12.8222 22.7L8 29H30.0909L23.4491 20Z" fill="#D1D3D4"/>
          <path d="M23.4491 20L24.2537 19.4062L23.5093 18.3975L22.6913 19.3475L23.4491 20ZM17.2501 27.2L16.5373 27.9014L17.2992 28.6757L18.0079 27.8525L17.2501 27.2ZM12.8222 22.7L13.535 21.9986L12.7277 21.1782L12.0281 22.0922L12.8222 22.7ZM8 29L7.20592 28.3922L5.97525 30H8V29ZM30.0909 29V30H32.0717L30.8955 28.4062L30.0909 29ZM22.6913 19.3475L16.4923 26.5475L18.0079 27.8525L24.2069 20.6525L22.6913 19.3475ZM17.9629 26.4986L13.535 21.9986L12.1094 23.4014L16.5373 27.9014L17.9629 26.4986ZM12.0281 22.0922L7.20592 28.3922L8.79408 29.6078L13.6163 23.3078L12.0281 22.0922ZM8 30H30.0909V28H8V30ZM30.8955 28.4062L24.2537 19.4062L22.6445 20.5938L29.2863 29.5938L30.8955 28.4062Z" fill="#D1D3D4" mask="url(#path-2-outside-1_591_4231)"/>
          <path d="M9.47917 18.9583C14.7144 18.9583 18.9583 14.7144 18.9583 9.47917C18.9583 4.24397 14.7144 0 9.47917 0C4.24397 0 0 4.24397 0 9.47917C0 14.7144 4.24397 18.9583 9.47917 18.9583Z" fill="#D1D3D4"/>
          <path d="M9.479 5.10416V13.8542" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.104 9.47916H13.854" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        <p class="mt-4">
          Sleep bestanden hier naartoe <br> <span class="link" @click="fileExplorer">of selecteer bestanden.</span>
        </p>

        <span class="formats">
          JPG-, GIF-, of PNG-formaat
        </span>
      </div>
    </div>
    <div v-else class="files-grid-wrapper flex-grow-1">
      <div
        class="files-grid"
        :class="[{hasMoreThanFour: computedFiles.length > 4}, selectedFile ? 'files-selected' : '']"
        ref="files-grid"
      >
        <div class="file-img placeholder-add d-flex justify-content-center align-items-center ignore-element" @click="fileExplorer">
          <svg width="50" height="50" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.5 47.9951C36.4787 47.9951 47 37.2511 47 23.9976C47 10.7441 36.4787 0 23.5 0C10.5213 0 0 10.7441 0 23.9976C0 37.2511 10.5213 47.9951 23.5 47.9951Z" fill="#D1D3D4"/>
            <path d="M23.5 12.9218V35.0734" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.6538 23.9976H34.3461" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <div v-for="file in computedFiles"
          class="file-img drag-handle"
          :class="{active: file.id === editingImageId}"
          :key="file.id"
          :data-id="file.id"
          @click="selectImageEdit(file.id)"
        >
          <span v-if="file.is_main" class="main-badged d-flex justify-content-center align-items-center">
            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="white">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </span>

          <img :src="file.src">

          <span v-if="file.caption"
            class="caption py-1 px-2"
            :class="{active: editingImageId === file.id}"
          >
            {{ file.caption }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="selectedFile" class="image-options flex-shrink-0 d-flex" ref="image-details">
      <div class="p-3">
        <div class="btn-actions">
          <button class="search" @click="zoom(selectedFile)">
            <svg width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.33538 7.67077C6.17747 7.67077 7.67077 6.17747 7.67077 4.33538C7.67077 2.4933 6.17747 1 4.33538 1C2.4933 1 1 2.4933 1 4.33538C1 6.17747 2.4933 7.67077 4.33538 7.67077Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.00008 9.00001L6.69238 6.69232" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4.38477 2.84616V5.92308" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2.84619 4.38461H5.92311" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Inzoomen
          </button>
          <button @click="editingImageId = null">
              <svg class="close-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
          </button>
        </div>
        <div class="mt-3">
          <FormCheckbox
            :value="selectedFile.is_main"
            :disableToggle="true"

            @click.native="setCurrentImageAsMain"
          >
            Hoofdafbeelding
          </FormCheckbox>
          <FormTextarea
            v-model="caption"
            class="mt-3"

            ref="textarea"
          />
        </div>
        <div class="mt-3 d-flex justify-content-end">
          <button class="btn-primary btn" @click="saveCaption">
            Afbeelding  opslaan
          </button>
        </div>
        <div class="mt-3 d-flex justify-content-end" @click="removeSelectedImage">
          <button class="d-flex align-items-center">
            <svg class="mr-2" width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
                <polyline points="11.5 5.5 10.5 13.5 3.5 13.5 2.5 5.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></polyline>
                <line x1="1" y1="3.5" x2="13" y2="3.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                <path d="M4.46,3.21l0-1.73a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v2" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
              </g></g>
            </svg>

            Afbeelding verwijderen
          </button>
        </div>
      </div>
    </div>

    <FileUploadDropzone @upload="uploadFiles"/>
  </div>
</template>

<script>

import FileUploadDropzone from "../../../../layout/FileUploadDropzone.vue"
import FormCheckbox from "../../../Inputs/FormCheckbox.vue"
import FormTextarea from "../../../Inputs/FormTextarea.vue"

import Sortable from "sortablejs"

export default {
  components: {
    FormTextarea,
    FileUploadDropzone,
    FormCheckbox,
  },
  props: {
    value: Array,
    productId: String,
  },
  data() {
    return {
      caption: "",
      editingImageId: null,
      hideFileInput: false,
      files: this.value || [],
      filesBeforeEditing: []
    }
  },
  mounted() {
    this.files.length && this.mountSortable()
    this.filesBeforeEditing = this.files;
  },
  methods: {
    async editImage(itemEdit) {
      await this.axios.put(
        `/api/products/${this.productId}/files/${this.editingImageId}`,
        itemEdit
      ).then(() => {
        this.filesBeforeEditing = this.files
      })
    },
    selectImageEdit(imageFid) {
      if(imageFid === this.editingImageId) return;
      this.editingImageId = imageFid;
      this.files = this.filesBeforeEditing;
    },
    setCurrentImageAsMain() {
      const mainItem = this.selectedFile.is_main
      mainItem
        ? this.files = this.files.map(item => ({...item, is_main: false }))
        : this.files = this.files.map(item => (item.fid === this.editingImageId ? { ...item, is_main: true } : { ...item, is_main: false }))
      this.editImage({ is_main: !mainItem })
    },
    saveCaption() {
      this.files = this.files.map(item => (item.fid === this.editingImageId ? { ...item, caption: this.caption } : item ))
      this.editImage({ caption: this.caption })
    },
    editCurrentItem(item) {
      const currentOne = this.selectedFile
      this.files.splice(
        this.files.findIndex(file => file.id === currentOne.id),
        1,
        {
          ...currentOne,
          ...item,
        }
      )
    },
    destroySortableInstance() {
      if (!this.instance) return;
      this.instance && this.instance.destroy()
      this.instance = null
    },
    mountSortable() {
      this.sortable = new Sortable(this.$refs["files-grid"], {
        handle: ".drag-handle",
        draggable: ".drag-handle",
        animation: 100,
        sort: true,
        filter: ".ignore-element",
        delay: 70,

        onUpdate: () => {
          this.$nextTick(async () => {
            const items = Array.from(this.$refs["files-grid"].children)
            this.$emit("update-order", items.map(item => item.dataset.id).filter(id => id))
          })
        },
      })
    },
    fileExplorer() {
      this.$refs.input.click()
    },
    change(evt) {
      const files = this.$refs.input.files ? Array.from(this.$refs.input.files) : null

      evt.preventDefault()
      if (!files || !files[0] || files.some(file => !file.type.includes("image"))) {
        return this.$error("Bestandsformaat niet beschikbaar")
      }

      this.uploadFiles(files)
    },
    uploadFiles(files) {
      try {
        const currentFiles = this.files
        const setFirstAsMain = currentFiles.length === 0

        files = files.map((item, index) => ({
          id: item.name + currentFiles.length + index,
          name: item.name,
          is_main: (setFirstAsMain && index === 0) || false,
          caption: "",
          file: item,
        }))
        if (files.length === 1) {
          this.editingImageId = files[0].id
        }

        if (this.productId) this.$emit('upload-files', files)

        this.files.push(...files)
        this.hideFileInput = true
        this.$nextTick(() => this.hideFileInput = false)
      } catch (err) {
        console.error(err)
      }
    },

    removeSelectedImage() {
      const activeId = this.editingImageId

      if (this.productId) {
        this.$emit("delete-file", activeId)
      }

      this.files.splice(
        this.files.findIndex(item => activeId === item.id),
        1
      )
    },
    checkTextAreaPath(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (
          node.classList && node.classList.contains("file-img") ||
          node === this.$refs["image-details"]
        ) {
          found = true
          break
        }
      }

      if (!found) this.editingImageId = null
    },
    zoom(number) {
      const file = this.selectedFile
      this.$store.commit("lightboxZoom", [file.src])
    }
  },
  computed: {
    selectedFile() {
      const editingImageId = this.editingImageId
      return this.computedFiles.find(file => file.id === editingImageId)
    },
    computedFiles() {
      return this.files.map(item => {
        const obj = {
          src: item.file && typeof item.file !== "string" ? URL.createObjectURL(item.file) : item.file,
          ...item,
        }

        if (item.url) {
          obj.src = item.url
        }
        if (item.fid) {
          obj.id = item.fid
        }

        return obj
      })
    },
  },
  watch: {
    editingImageId(val) {
      this.caption = ""
      if (val) {
        const item = this.selectedFile
        this.caption = item.caption
        this.is_main = item.is_main
      }

      requestAnimationFrame(() => {
        if (val) {
          window.addEventListener("click", this.checkTextAreaPath, {passive: true})
        } else {
          window.removeEventListener("click", this.checkTextAreaPath)
        }
      })

      val && this.$nextTick(() => {
        requestAnimationFrame(() => this.$refs.textarea.focusInput())
      })
    },
    files(val) {
      if (val && val.length) {
        this.destroySortableInstance()
      } else {
        this.$nextTick(this.mountSortable)
      }

      const files = val.map(item => ({...item}))
      if (!files.some(item => item.is_main)) {
        files[0].is_main = true
      }

      this.$emit("input", files)
    },
  },
}

</script>

<style scoped>

.NewImagesHandler {
  border: 1px solid #D1D3D4;
  height: 375px;
}

.files-grid-wrapper {
  position: relative;
}

.files-grid {
  position: absolute;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px;
  column-count: 5;
}

.files-selected {
  overflow-y: auto;
  height: 100%;
}

.file-img {
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  cursor: pointer !important;
  pointer-events: all !important;
  width: calc((100% / 2) - 5px);
  height: 105px;
  object-fit: cover;
}

@media (min-width: 1200px) {
  .file-img {
    width: calc((100% / 5) - 8px);
  }

  .files-selected .file-img {
    width: calc((100% / 2) - 8px);
  }
}

.file-img.placeholder-add {
  border: 1px solid #D1D3D4;
  height: 105px;
  cursor: pointer;
  margin-left: 0;
  padding-right: 0;
}

.main-badged {
  display: block;
  position: absolute;
  right: 0px;
  top: 0px;
  margin-top: 4px;
  margin-right: 4px;
  height: 25px;
  width: 25px;
  border-radius: 500px;
  background-color: var(--mint-green);
}

.caption {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--mint-green);
  color: white;
  z-index: 5;
  transform: translateY(100%);
  transition-duration: .15s;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.caption.active, .file-img:hover .caption {
  transform: translateY(0%);
}

.file-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.file-img.active {
  border: 2px solid #33C9D2 !important;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}

.search {
  color: #33C9D2;
  cursor: pointer;
}

p {
  font-size: 20px;
  text-align: center;
  font-weight: 500;
}

.link {
  text-decoration: underline;
  cursor: pointer;
}

.formats {
  margin-top: 28px;
}

.image-options {
  flex-basis: 250px;
}

.image-options > div {
  border-left: 1px solid #D1D3D4;
  width: 100%;
}

@media (max-width: 798px) {
  .NewImagesHandler {
    flex-direction: column;
    height: auto;
  }

  .files-grid {
    position: initial;
  }

  .image-options > div {
    border-top: 1px solid #D1D3D4;
    border-left: none;
  }
}

</style>
